<template>
<Menu :active-name="current" @on-select="onSelect">
  <MenuItem name="progress">
    <Icon type="ios-stats" /> 研究进度
  </MenuItem>
  <MenuItem name="subject">
  <Icon type="ios-people" /> 病例构成
  </MenuItem>
  <MenuItem name="sdv">
    <Icon type="ios-checkmark-circle-outline" /> SDV统计
  </MenuItem>
  <MenuItem name="query">
    <Icon type="ios-help-circle" /> 疑问统计
  </MenuItem>
  <!-- <MenuItem name="followup">
    <Icon type="md-calendar" /> 随访统计
  </MenuItem>
  <MenuItem name="task">
    <Icon type="ios-list" /> 任务统计
  </MenuItem> -->
</Menu>
</template>

<script>
export default {
  name: 'stat-menu',
  data: function () {
    return {
      current: 'progress'
    }
  },
  methods: {
    onSelect: function (name) {
      var baseUrl = '/study/' + this.$route.params.id + '/stat/'
      var url = baseUrl + this.getUrl(name)
      this.$router.push(url)
      this.activeItem(name)
    },
    getUrl: function (name) {
      return name.split('-').join('/')
    },
    activeItem: function (name) {
      this.current = name
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
